import { useEffect, useRef } from 'react';
import { useAuthContext } from './useAuthContext';
import { sendMetric } from '/src/utils/metrics';

export function useFeatureMetric(feature, extra = {}) {
  const hasSentMetric = useRef(false);
  const { currentUser } = useAuthContext();

  useEffect(() => {
    if (currentUser && !hasSentMetric.current) {
      sendMetric('feature_used', {
        feature,
        user_id: currentUser.userId,
        guest_id: currentUser.guestId,
        ...extra,
      });
      hasSentMetric.current = true;
    }
  }, [currentUser, feature, extra]);
}
